import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  input,
  output
} from '@angular/core';
import { Router } from '@angular/router';
import { QUINNY_AI_AVATAR_URL } from '@core';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';
import { SettingsService, User } from '@delon/theme';
import { NzModalService } from 'ng-zorro-antd/modal';
import { FcwidgetService } from 'src/app/core/util/fcwidget.service';
import { PhEisMenuModeService } from 'src/app/core/services/ph-eis-menu-mode.service';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'header-mobile-dropdown-nav',
  templateUrl: './mobile-dropdown-nav.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule]
})
export class HeaderMobileDropdownNavComponent {
  readonly quinnyAiAvatarUrl = QUINNY_AI_AVATAR_URL;

  showSearchIcon = input<boolean>(false);
  requestLock = output<any>();
  requestChatbot = output<any>();
  requestAISupport = output<any>();
  requestSearch = output<any>();

  get user(): User {
    return this.settings.user;
  }

  constructor(
    private readonly settings: SettingsService,
    private readonly modalSrv: NzModalService,
    private readonly router: Router,
    private readonly fcWidget: FcwidgetService,
    @Inject(DA_SERVICE_TOKEN) private readonly tokenService: ITokenService,
    readonly menuMode: PhEisMenuModeService
  ) {}

  openMarketplace() {
    this.router.navigate(['./marketplace/partners']);
  }

  openChat() {
    const chatbot = document.getElementById('chatbot-window');
    if (chatbot?.style.display === 'block') {
      chatbot.style.display = 'none';
    }
    this.fcWidget.openWithUserContext();
  }

  openUrl() {
    let country = this.settings.user['company'].country;

    if (country === 'PH') {
      window.open(
        `https://support.qne.com.ph/support/solutions/35000142932`,
        '_blank'
      );
    } else if (country === 'MM') {
      window.open(`https://qnemm.freshdesk.com/support/home`, '_blank');
    } else {
      window.open(
        `https://support.qne.com.my/support/solutions/81000205493`,
        '_blank'
      );
    }
  }
}
